import { ArrowRightIcon } from './ArrowRightIcon';

/**
 * author: Google
 * id 05F25B05-A6D6-4863-8B21-6969E10329CF
 * name arrow-right
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/arrow-right.svg
 * tags
 * - Arrow 
 */
export const ArrowForwardIcon = ArrowRightIcon;
export default ArrowForwardIcon